import { render } from "./StafetDeltagPaaHoldFlow.vue?vue&type=template&id=7dfec5eb"
import script from "./StafetDeltagPaaHoldFlow.vue?vue&type=script&lang=js"
export * from "./StafetDeltagPaaHoldFlow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__